module.exports = __webpack_public_path__ + "static/media/interface_left_data.6d911465.png";